import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Raschet.module.scss'

import { Container, Image } from 'react-bootstrap'

import SimleForm from './SimleForm'

class Raschet extends React.Component {

  render() {

    const { assets_path, data, dark_bg, dark_bg_mob, variant } = this.props

    if(variant == `raschet`) return (
      <section className={styles.section}>
        {dark_bg != '' &&
          <>
            <Image className={styles.section_bg} src={dark_bg} width={1920} height={299} alt={`Фон`} />
            <Image className={styles.section_bg_mob} src={dark_bg_mob} width={375} height={482} alt={`Фон моб.`} />
          </>
        }
        <div className={styles.section_content}>
          <Container>
            <h2 className={styles.title} dangerouslySetInnerHTML={{__html: data?.title}} />
            <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.text}} />
          </Container>
          <div className={styles.sep}></div>
          <Container>
            <SimleForm
              btn={`Получить расчет стоимости`}
              assets_path={assets_path}
              width={233}
              name={true}
            />
            {data?.image != '' &&
              <div className={styles.section_image_container}>
                <Image className={styles.section_image} src={data?.image} alt={`${data?.title} - фото`} width={475} height={319} />
                <Image className={styles.section_image_mob} src={data?.image_mob} alt={`${data?.title} - фото моб.`} width={375} height={283} />
              </div>
            }
          </Container>
        </div>
      </section>
    )

    if(variant == `zavod`) return (
      <section className={styles.section}>
        {dark_bg != '' &&
          <>
            <Image className={styles.section_bg} src={dark_bg} width={1920} height={299} alt={`Фон`} />
            <Image className={styles.section_bg_mob} src={dark_bg_mob} width={375} height={482} alt={`Фон моб.`} />
          </>
        }
        <div className={styles.section_content}>
          <Container>
            <h2 className={styles.title} dangerouslySetInnerHTML={{__html: data?.title}} />
            <div className={styles.text2} dangerouslySetInnerHTML={{__html: data?.text}} />
          </Container>
          <div className={styles.sep}></div>
          <Container>
            <SimleForm
              btn={`Записаться`}
              assets_path={assets_path}
              width={144}
              name={true}
            />
            {data?.image != '' &&
              <div className={styles.section_image_container}>
                <Image className={styles.section_image2} src={data?.image} alt={`${data?.title} - фото`} width={586} height={287} />
                <Image className={styles.section_image_mob} src={data?.image_mob} alt={`${data?.title} - фото моб.`} width={375} height={222} />
              </div>
            }
          </Container>
        </div>
      </section>
    )
  }
}

Raschet.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string,
  dark_bg: PropTypes.string,
  dark_bg_mob: PropTypes.string,
  variant: PropTypes.string
}

Raschet.defaultProps = {
  data: {},
  assets_path: 'assets',
  dark_bg: '',
  dark_bg_mob: '',
  variant: `raschet`
}

export default Raschet